import type { ReactNode } from 'react';

import { cn } from '../../lib/cn';
import styles from './Badge.module.css';

export type BadgeTone =
  | 'neutral'
  | 'primary'
  | 'accent'
  | 'success'
  | 'warning'
  | 'danger'
  | 'todo'
  | 'progress'
  | 'done';

export type BadgeProps = {
  readonly tone?: BadgeTone;
  readonly children: ReactNode;
  readonly dotColor?: string;
};

export function Badge({ tone = 'neutral', children, dotColor }: BadgeProps) {
  return (
    <span className={cn(styles['badge'], styles[tone])}>
      {dotColor ? <span aria-hidden className={styles['dot']} style={{ background: dotColor }} /> : null}
      {children}
    </span>
  );
}
